import { AvvirEvent } from "type_aliases";
import { ApiMinimalPlannedBuildingElement } from "avvir";

export type MinimalPlannedBuildingElementsLoadedEvent = AvvirEvent<typeof MINIMAL_PLANNED_BUILDING_ELEMENTS_LOADED, { floorId: string, elements: ApiMinimalPlannedBuildingElement[] }>

/**
 * Carries the slim per-floor payload — globalId, builtStatus, trade, uniformat, excludeFromAnalysis.
 */
const minimalPlannedBuildingElementsLoaded = (floorId: string, elements: ApiMinimalPlannedBuildingElement[]): MinimalPlannedBuildingElementsLoadedEvent => ({
  type: MINIMAL_PLANNED_BUILDING_ELEMENTS_LOADED,
  payload: {
    floorId,
    elements
  }
});

export const MINIMAL_PLANNED_BUILDING_ELEMENTS_LOADED = "minimal_planned_building_elements_loaded";

export default minimalPlannedBuildingElementsLoaded;
